export function objectToFormData(
  obj: Record<string, any>,
  formData = new FormData(),
  parentKey = ''
) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      const fullKey = parentKey ? `${parentKey}[${key}]` : key;

      if (value instanceof File) {
        // If the value is a File, append it directly
        formData.append(fullKey, value);
      } else if (Array.isArray(value)) {
        // If the value is an array, iterate over its elements
        value.forEach((item, index) => {
          const arrayKey = `${fullKey}[${index}]`;
          if (typeof item === 'object' && item !== null) {
            // If the element is an object or array, recursively process it
            objectToFormData(item, formData, arrayKey);
          } else {
            // Otherwise, append the element as a string
            formData.append(arrayKey, item);
          }
        });
      } else if (typeof value === 'object' && value !== null) {
        // If the value is an object, recursively process it
        objectToFormData(value, formData, fullKey);
      } else if (typeof value === 'boolean') {
        formData.append(fullKey, value ? '1' : '0');
      } else {
        // Otherwise, append the value as a string
        formData.append(fullKey, value);
      }
    }
  }
  return formData;
}
